<script>
export default {
	name: 'IconSvgOdt',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_12_361)">
				<path
					d="M13.3995 4.104C12.9347 4.10356 12.4891 3.92241 12.1604 3.60029C11.8316 3.27818 11.6466 2.84138 11.646 2.38572V0H3.81493C3.20829 0 2.62648 0.23626 2.19752 0.656792C1.76856 1.07733 1.52759 1.64768 1.52759 2.2424V15.7602C1.52759 16.3549 1.76856 16.9253 2.19752 17.3458C2.62648 17.7663 3.20829 18.0026 3.81493 18.0026H13.2159C13.8226 18.0026 14.4044 17.7663 14.8333 17.3458C15.2623 16.9253 15.5033 16.3549 15.5033 15.7602V4.104H13.3995Z"
					:fill="color" />
				<path
					d="M15.5033 4.104H13.3996C12.9348 4.10356 12.4891 3.92241 12.1604 3.60029C11.8317 3.27818 11.6467 2.84138 11.646 2.38572V0L15.5033 4.104Z"
					fill="#0055A3" />
				<path
					d="M12.6287 6.97717H3.85245C3.7682 6.97695 3.68748 6.94404 3.62791 6.88564C3.56834 6.82724 3.53477 6.7481 3.53455 6.66551C3.53455 6.58278 3.568 6.50342 3.6276 6.44484C3.68719 6.38626 3.76805 6.35325 3.85245 6.35303H12.6287C12.7131 6.35325 12.7939 6.38626 12.8535 6.44484C12.9131 6.50342 12.9466 6.58278 12.9466 6.66551C12.9464 6.7481 12.9128 6.82724 12.8532 6.88564C12.7937 6.94404 12.7129 6.97695 12.6287 6.97717Z"
					fill="#0055A3" />
				<path
					d="M12.6287 8.8413H3.85245C3.7682 8.84108 3.68748 8.80817 3.62791 8.74977C3.56834 8.69138 3.53477 8.61224 3.53455 8.52965C3.53455 8.44692 3.568 8.36756 3.6276 8.30898C3.68719 8.2504 3.76805 8.21738 3.85245 8.21716H12.6287C12.7131 8.21738 12.7939 8.2504 12.8535 8.30898C12.9131 8.36756 12.9466 8.44692 12.9466 8.52965C12.9464 8.61224 12.9128 8.69138 12.8532 8.74977C12.7937 8.80817 12.7129 8.84108 12.6287 8.8413Z"
					fill="#0055A3" />
				<path
					d="M12.6287 10.7054H3.85245C3.76805 10.7052 3.68719 10.6722 3.6276 10.6136C3.568 10.555 3.53455 10.4757 3.53455 10.393C3.53477 10.3104 3.56834 10.2312 3.62791 10.1728C3.68748 10.1144 3.7682 10.0815 3.85245 10.0813H12.6287C12.7129 10.0815 12.7937 10.1144 12.8532 10.1728C12.9128 10.2312 12.9464 10.3104 12.9466 10.393C12.9466 10.4757 12.9131 10.555 12.8535 10.6136C12.7939 10.6722 12.7131 10.7052 12.6287 10.7054Z"
					fill="#0055A3" />
				<path
					d="M12.6287 12.5686H3.85245C3.76813 12.5686 3.68728 12.5358 3.62766 12.4773C3.56804 12.4189 3.53455 12.3396 3.53455 12.2569C3.53455 12.1742 3.568 12.0949 3.6276 12.0363C3.68719 11.9777 3.76805 11.9447 3.85245 11.9445H12.6287C12.7131 11.9447 12.7939 11.9777 12.8535 12.0363C12.9131 12.0949 12.9466 12.1742 12.9466 12.2569C12.9466 12.3396 12.9131 12.4189 12.8535 12.4773C12.7939 12.5358 12.713 12.5686 12.6287 12.5686Z"
					fill="#0055A3" />
				<path
					d="M17.1625 14.2169H6.53405C5.78013 14.2169 5.16895 14.8161 5.16895 15.5552V18.6617C5.16895 19.4008 5.78013 20 6.53405 20H17.1625C17.9164 20 18.5276 19.4008 18.5276 18.6617V15.5552C18.5276 14.8161 17.9164 14.2169 17.1625 14.2169Z"
					fill="#0055A3" />
				<path
					d="M13.586 17.7217C13.4796 17.9112 13.3188 18.0659 13.1236 18.1667C12.9039 18.277 12.6597 18.3317 12.413 18.3259H11.4482V15.8202H12.413C12.6599 15.8141 12.9045 15.8676 13.1253 15.976C13.32 16.0746 13.4803 16.2278 13.586 16.416C13.6966 16.6158 13.7522 16.8403 13.7475 17.0676C13.7521 17.2957 13.6965 17.521 13.586 17.7217ZM12.9213 17.5959C12.9904 17.5264 13.0439 17.4435 13.0785 17.3525C13.113 17.2615 13.1278 17.1645 13.1219 17.0676C13.1278 16.9708 13.1131 16.8739 13.0785 16.7831C13.044 16.6922 12.9904 16.6095 12.9213 16.5401C12.7667 16.4071 12.5647 16.3394 12.3594 16.3518H12.0662V17.7834H12.3594C12.5646 17.7956 12.7664 17.7283 12.9213 17.5959Z"
					fill="#F3F3F6" />
				<path d="M15.9239 15.8206V16.303H15.2294V18.3263H14.6081V16.303H13.9204V15.8206H15.9239Z"
					  fill="#F3F3F6" />
				<path
					d="M10.5173 15.9864C10.7115 16.0946 10.8722 16.2524 10.9822 16.4431C11.0972 16.6451 11.1559 16.8733 11.1522 17.1047C11.1568 17.3378 11.0982 17.5678 10.9822 17.7713C10.8719 17.9629 10.7106 18.1216 10.5156 18.2305C10.3169 18.3417 10.0916 18.3993 9.86281 18.3972C9.63403 18.3991 9.40879 18.3416 9.21004 18.2305C9.01506 18.1218 8.85402 17.9631 8.74427 17.7713C8.62791 17.568 8.56922 17.3378 8.57428 17.1047C8.56984 16.8733 8.62852 16.6448 8.74427 16.4431C8.8546 16.2524 9.01556 16.0946 9.21004 15.9864C9.40879 15.8753 9.63403 15.8178 9.86281 15.8198C10.0922 15.8176 10.318 15.8751 10.5173 15.9864ZM9.37833 16.5781C9.25287 16.7251 9.18907 16.9133 9.19984 17.1047C9.18973 17.2952 9.25349 17.4825 9.37833 17.6289C9.43941 17.6939 9.51428 17.7451 9.59768 17.7788C9.68108 17.8125 9.771 17.8279 9.86111 17.8238C9.95093 17.8275 10.0405 17.812 10.1235 17.7783C10.2066 17.7446 10.2812 17.6936 10.3422 17.6289C10.4682 17.483 10.5326 17.2956 10.5224 17.1047C10.5326 16.9139 10.4689 16.7263 10.3439 16.5797C10.2828 16.5146 10.208 16.4634 10.1246 16.4297C10.0412 16.396 9.95123 16.3807 9.86111 16.3847C9.77146 16.3811 9.68205 16.3965 9.59902 16.4299C9.51599 16.4632 9.44129 16.5138 9.38003 16.5781H9.37833Z"
					fill="#F3F3F6" />
				<path d="M8.41276 17.7797V18.3855H7.77271V17.7797H8.41276Z" fill="#F3F3F6" />
			</g>
			<defs>
				<clipPath id="clip0_12_361">
					<rect width="20" height="20" fill="white" transform="translate(0.0275879)" />
				</clipPath>
			</defs>
		</svg>

	</div>
</template>

<style scoped>

</style>